import { render, staticRenderFns } from "./UploadAnswerType.vue?vue&type=template&id=64915922&"
import script from "./UploadAnswerType.vue?vue&type=script&lang=js&"
export * from "./UploadAnswerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports